import { BOS_LINKS } from 'constants/general';
export const MENU_ITEMS = [
    {
        title: 'BitcoinOS',
        url: BOS_LINKS.BITCOINOS,
    },
    {
        title: 'Whitepaper',
        url: BOS_LINKS.WHITEPAPER,
        openInNewTab: true,
    },
    {
        title: 'Roadmap',
        url: BOS_LINKS.ROADMAP,
        openInNewTab: true,
    },
    {
        title: '$BOS Presale',
        url: BOS_LINKS.BOS_PRESALE,
    },
];
